import { inputPathPermissionsGQLFields } from './inputPathPermissions.fields.js';
import { isAuthorizedGQLFields } from './isAuthorized.fields.js';
import { pathPermissionsGQLFields } from './pathPermissions.fields.js';
export function actionPermissionGQLFields(
// eslint-disable-next-line @typescript-eslint/no-unused-vars
fields) {
    return `
    name
    isAuthorized {
      ${isAuthorizedGQLFields('basic')}
    }
    inputPermissions {
      ${inputPathPermissionsGQLFields('basic')}
    }
    outputPermissions {
      ${pathPermissionsGQLFields('basic')}
    }
  `;
}
//# sourceMappingURL=actionPermissions.fields.js.map